import { useEffect, useState } from 'react'
import useOnPremAgentClient from '~/api/OnPremAgentClient/useOnPremAgentClient'
import Button from '~/components/buttons/Button'
import { StructuredDataFormData } from '~/components/StructuredDataForm/StructuredDataForm'
import Toaster from '~/components/Toaster'
import CloudSettingsForm from './CloudSettingsForm'
import cs from './cloud_settings.scss'

export default function CloudSettings() {
  const [configValues, setConfigValues] = useState<StructuredDataFormData>({})
  const client = useOnPremAgentClient()

  const fetchConfig = async () => {
    const config = await client.cloud.getConfig()
    setConfigValues(config)
  }

  useEffect(() => {
    fetchConfig()
  }, [])

  const testConnection = async () => {
    try {
      await client.cloud.verifyCloudConnection()
      Toaster.show({
        message: 'Successfully connected to cloud',
        intent: 'success',
      })
    } catch (_e) {
      Toaster.show({
        message: 'Failed to connect to cloud using the saved settings',
        intent: 'danger',
      })
    }
  }
  const saveSettings = async () => {
    try {
      await client.cloud.updateConfig(configValues)
      Toaster.show({
        message: 'Successfully saved cloud settings',
        intent: 'success',
      })
    } catch (_e) {
      Toaster.show({
        message: 'Failed to save cloud settings',
        intent: 'danger',
      })
    }
  }

  return (
    <div className={cs.cloudSettings}>
      <div className={cs.topBar}>
        <div className={cs.controls}>
          <div className={cs.cloudSettings}> Cloud Settings </div>
          <div className={cs.spacer} />
          <Button
            type='primary'
            label='Save'
            onClick={saveSettings}
            className={cs.button}
          />
          <Button
            label='Test Connection'
            onClick={testConnection}
            className={cs.button}
          />
        </div>
      </div>
      <CloudSettingsForm
        className={cs.configForm}
        configValues={configValues}
        setConfigValues={setConfigValues}
      />
    </div>
  )
}
